import React from 'react'
import { FaRegHeart, FaHeart } from 'react-icons/fa'
import { firestore, auth, signInWithGoogle } from '../../firebase/firebase-utils'

const Likes = ({ docid, collection }) => {

    const [liked, setliked] = React.useState(false);
    const [likes, setlikes] = React.useState([]);
    const [User, setUser] = React.useState(null)

    auth.onAuthStateChanged(async user => {
        if (user) {
            await setUser(user)
        }
    })

    React.useEffect(() => {
        firestore.collection(collection).doc(docid).onSnapshot((feed) => {
            if (feed.exists) {
                var query = feed.data().likes;
                if (query) {
                    setlikes(query)
                    if (User) {
                        var count = query.reduce((acc, ele) => {
                            return ele === User.uid ? acc + 1 : acc
                        }, 0)
                        if (count === 1) { setliked(true) } else (setliked(false))
                    }
                }
            }
        })
    }, [docid, collection, User])

    const PostLike = () => {
        if (User && likes) {
            var array = likes;
            array.push(User.uid);
            firestore.collection(collection).doc(docid).update({
                likes: array
            })
        } else { window.alert("sign In required ..."); signInWithGoogle() }
    }

    const PostDislike = () => {
        if (User && likes) {
            var array = likes;
            array = likes.filter(uid => (uid !== User.uid))
            firestore.collection(collection).doc(docid).update({
                likes: array
            })
        } else { window.alert("sign In required ..."); signInWithGoogle() }
    }

    return (
        <>
            {
                liked ?
                    <><FaHeart style={{ color: 'tomato' }} onClick={PostDislike} />{'  '}<span>{likes.length}</span></>
                    :
                    <><FaRegHeart onClick={PostLike} />{'  '}<span>{likes.length}</span></>
            }
        </>
    )
}

export default Likes
